module.exports = __webpack_public_path__ + "img/news-content-back.aac4b520.png";